/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteSchedulesModal_ScheduleFragment = { __typename: 'Schedule', id: string, isScheduleUsedByAnyConfiguration: boolean, allDisplays: Array<{ __typename: 'Display', id: string }> };

export type DeleteSchedulesMutationVariables = Types.Exact<{
  input: Types.SchedulesDeleteInput;
}>;


export type DeleteSchedulesMutation = { __typename: 'Mutation', schedulesDelete: { __typename: 'SchedulesDeletePayload', scheduleIds: Array<string> } };

export const DeleteSchedulesModal_ScheduleFragmentDoc = gql`
    fragment DeleteSchedulesModal_schedule on Schedule {
  id
  isScheduleUsedByAnyConfiguration
  allDisplays: displays {
    id
  }
}
    `;
export const DeleteSchedulesDocument = gql`
    mutation DeleteSchedules($input: SchedulesDeleteInput!) {
  schedulesDelete(input: $input) {
    scheduleIds
  }
}
    `;
export type DeleteSchedulesMutationFn = ApolloReactCommon.MutationFunction<DeleteSchedulesMutation, DeleteSchedulesMutationVariables>;

/**
 * __useDeleteSchedulesMutation__
 *
 * To run a mutation, you first call `useDeleteSchedulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSchedulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSchedulesMutation, { data, loading, error }] = useDeleteSchedulesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSchedulesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteSchedulesMutation, DeleteSchedulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteSchedulesMutation, DeleteSchedulesMutationVariables>(DeleteSchedulesDocument, options);
      }
export type DeleteSchedulesMutationHookResult = ReturnType<typeof useDeleteSchedulesMutation>;
export type DeleteSchedulesMutationResult = ApolloReactCommon.MutationResult<DeleteSchedulesMutation>;
export type DeleteSchedulesMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteSchedulesMutation, DeleteSchedulesMutationVariables>;